import { Translation } from "../i18n-types";

const si: Translation = {
    "state-is-required": "State is required field.",
    description: {
        "show-more": "Pokaži več",
        "show-less": "Prikaži manj"
    },
    footer: {
        "why-shop-with-us": "Zakaj po vaših besedah ​​nakupujete pri nas?",
        "heureka-image-url": "/footer/img/si/comparator.png",
        benefits: {
            first: "super hitra dostava",
            second: "zelo hiter in zanesljiv servis",
            third: "prijazen pristop k podpori strankam"
        },
        social: {
            "facebook-plugin-url":
                "https://www.facebook.com/plugins/page.php?href=https%3A%2F%2Fwww.facebook.com%2Ffoxigy.si&tabs&width=314&height=130&small_header=false&adapt_container_width=true&hide_cover=false&show_facepile=true&appId",
            "facebook-page-url": "https://www.facebook.com/foxigy.si",
            "instagram-page-url": "https://www.instagram.com/foxigy.si/",
            "youtube-page-url": "https://www.youtube.com/channel/UCCDFZ4x2LHxKPa_5t9OCyKQ"
        },
        "your-foxigy-image-link": "/footer/img/si/your-foxigy.png"
    }
};

export default si;
